import { makeAutoObservable } from 'mobx';

export class SessionStore {
  isProfileActive = true;

  isSessionTimeout = false;

  constructor() {
    makeAutoObservable(this);
  }

  setProfileActive(isActive: boolean) {
    this.isProfileActive = isActive;
  }

  setSessionTimeout(isTimeout: boolean) {
    this.isSessionTimeout = isTimeout;
  }
}

const sessionStore = new SessionStore();

export default sessionStore;
